<template>
  <v-select
    v-model="model"
    v-bind="$attrs"
    :clearable="clearable"
    :rules="rules"
    flat
    outlined
    rounded
  />
</template>

<script>
export default {
  name: "CVISelect",
  props: {
    clearable: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    validator: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [Number, String, Object, Boolean],
      default: null,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
    rules() {
      const rules = this.required
        ? [...this.validator, (v) => !!v || "Este campo é obrigatório"]
        : [...this.validator];

      return rules;
    },
  },
};
</script>
